import withStyles from '@mui/styles/withStyles';
import { TableCell } from '@mui/material';

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: 'rgba(42, 29, 29, 0.9)',
    color: '#fff',
    fontSize: '1rem',
    fontWeight: 'bold',
    paddingBottom: 4,
    paddingRight: 4,
    paddingTop: 4,
    textTransform: 'uppercase',
  },

  body: {
    border: 'none',
    fontSize: 12,
    paddingBottom: 4,
    paddingTop: 4,
  },
}))(TableCell);

export default StyledTableCell;
